module.exports = __webpack_public_path__ + "img/editable_icon.2a3d5213.svg";